import { CustomTooltip } from '../tooltip/CustomTooltip';
import { MenuProps } from './Menu.interface';
import { CustomMenuItem, Menu as MuiMenu } from './Menu.styled';

export const Menu = (props: MenuProps) => {
  const open = Boolean(props.anchorEl);

  const renderMenuItem = (item: any, index: number) => {
    const menuItem = (
      <CustomMenuItem
        key={item.label + index}
        onClick={item.onClick}
        $isSelected={item.isSelected}
        disabled={item.disabled}
        $hasProductVariation={!!item.productVariation}
        $destructive={!!item.destructive}>
        {item.leftIcon}
        {item.label}
      </CustomMenuItem>
    );

    return (item.productVariation || item.tooltip) && item.disabled ? (
      <CustomTooltip
        key={item.label + index}
        width={item.tooltipWidth ?? 170}
        placement={item.tooltipPlacement || 'bottom'}
        title={item.tooltip}
        skipValidateOverflow={true}>
        {menuItem}
      </CustomTooltip>
    ) : (
      menuItem
    );
  };

  return (
    <MuiMenu
      anchorEl={props.anchorEl}
      open={open}
      onClose={props.onClose}
      autoFocus={false}>
      {props.items.map(renderMenuItem)}
    </MuiMenu>
  );
};
